export default {
  computed: {
    isDark() {
      return !!this?.$vuetify?.theme?.dark;
    },
    colorTheme() {
      return this.isDark ? 'dark' : 'light';
    },
  },
  methods: {
    themeMixinGetColor() {
      return this.$colorUtil.getThemedColor(this.$vuetify.theme.dark);
    },
  },
};
